

import React, { useState, useRef, useEffect } from 'react'
import './index.scss';
function Rate({
    info,
}) {
    const [textPos, setTextPos] = useState(0);
    const textDom = useRef(null);
    const rateDom = useRef(null);
    const [rate, setRate] = useState(0);
    const [clc, setClc] = useState(0);
    const fz = +getComputedStyle(window.document.documentElement)['font-size'].split('px')[0];
    useEffect(() => {
        const ra = info.rate;
        console.log(ra)
        setRate(ra * 100);
        setClc(2.54 * ra - 0.08);
    }, [info])


    useEffect(() => {
        let com = rateDom.current.offsetWidth*info.rate - textDom.current.offsetWidth/2;
        setTextPos(com);
    }, [info, rate])
    return (
         <>
            <div className='home-box-title'>
                <img src='https://img14.360buyimg.com/imagetools/jfs/t1/165134/2/15160/4809/605ab2b7Edda5ed5a/89bcbef4f253cf73.png' />
                {info.rewardName?<div>{info.reachTitle} 领{info.rewardName}</div>: null}
            </div>
            <div className='home-rate-box'>
                <div className='rate-bg'>
                    <div className='rate-fill-left'></div>
                    <div className='rate-fill-right'></div>
                    <div className='rate-fill-clc' ref={rateDom}>
                        <div className='rate-fill-real' style={{ width: `${rate}%` }}></div>
                        <div className='rate-clc' style={{ left: `${clc}rem` }}>
                            <div className='rate-inclc'></div>
                        </div>
                        <div className='rate-bg-text' ref={textDom} style={{ left: textPos }}>
                            已攒<span className='rate-text-accrue'>{info.accrue}</span>{info.reachUnitText}
                            <div><span></span></div>
                        </div>
                    </div>
                </div>
                <div className='rate-mark'>
                    <div><span>0</span>{info.reachUnitText}</div>
                    <div><span>{info.reachNumber}</span>{info.reachUnitText}</div>
                </div>
            </div>
        </>
    )
}

export default React.memo(Rate);
